import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom"; 
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "./scss/main.scss";
import 'react-quill/dist/quill.snow.css';
import configureStoreProd from "./redux/configureStore.prod";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify"; 
import { lazy, Suspense, useEffect } from "react";

const { persistor, store } = configureStoreProd();


const PageRoute = ({ url, auth = false, children }: any) => {
  const user = useSelector((state: any) => state.user)
  const navigate = useNavigate()

  let noAccess = false
  if(!user.loggedIn && auth)noAccess=true

  useEffect(() => {
    if (!user.loggedIn) navigate('/login')
  }, [url])

  if (noAccess) return <></>

  return <>{children}</>
}

function App() {
  const routes = [ 
    { url: "/login", Component: lazy(() => import('./pages/auth/login')) }, 
    { url: "/", element: <Navigate to="/login" /> },
    { url: "/dashboard",Component: lazy(() => import('./pages/dashboard')),auth:true },
    { url: "*",Component: lazy(() => import('./pages/NotFoundPage')),auth:true },
    { url: "/profile",Component: lazy(() => import('./pages/auth/profile')),auth:true }, 
    { url: "/profile/edit", Component: lazy(() => import('./pages/auth/profile/editprofile')),auth:true  }, 
    { url: "/forgotpassword",  Component: lazy(() => import('./pages/auth/forgotpassword')) },
    // { url: "/resetpassword", Component: lazy(() => import('./pages/auth/forgotpassword')) },
    { url: "/changepassword", Component: lazy(() => import('./pages/auth/changepassword')),auth:true  },
    { url: "/roles", Component: lazy(() => import('./pages/roles')),auth:true  },
    { url: "/roles/add", Component: lazy(() => import('./pages/roles/AddEdit')),auth:true },
    { url: "/roles/edit/:id", Component: lazy(() => import('./pages/roles/AddEdit')),auth:true }, 
    { url: "/roles/detail/:id", Component: lazy(() => import('./pages/roles/View')),auth:true }, 
    { url: "/plans",Component: lazy(() => import('./pages/plans')),auth:true },
    { url: "/plans/add", Component: lazy(() => import('./pages/plans/AddEdit')),auth:true  },
    { url: "/plans/edit/:id", Component: lazy(() => import('./pages/plans/AddEdit')),auth:true  },
    { url: "/plans/detail/:id", Component: lazy(() => import('./pages/plans/detail')),auth:true  },
    { url: "/features", Component: lazy(() => import('./pages/features')),auth:true  },
    { url: "/features/add", Component: lazy(() => import('./pages/features/AddEdit')),auth:true  },
    { url: "/features/edit/:id", Component: lazy(() => import('./pages/features/AddEdit')),auth:true  },
    { url: "/features/detail/:id", Component: lazy(() => import('./pages/features/detail')) ,auth:true  },
    
    { url: "/broadcast",Component: lazy(() => import('./pages/broadcast')),auth:true  },
    { url: "/broadcast/add", Component: lazy(() => import('./pages/broadcast/AddEdit')),auth:true  },
    { url: "/broadcast/detail/:id", Component: lazy(() => import('./pages/broadcast/View')),auth:true  },
    { url: "/broadcast/edit/:id", Component: lazy(() => import('./pages/broadcast/AddEdit')),auth:true  },

    { url: "/announcement",Component: lazy(() => import('./pages/announcement')),auth:true  },
    { url: "/announcement/add", Component: lazy(() => import('./pages/announcement/AddEdit')),auth:true  },
    { url: "/announcement/detail/:id", Component: lazy(() => import('./pages/announcement/View')),auth:true  },
    { url: "/announcement/edit/:id", Component: lazy(() => import('./pages/announcement/AddEdit')),auth:true  },

    { url: "/patients",Component: lazy(() => import('./pages/patients')),auth:true  },
    { url: "/patients/add", Component: lazy(() => import('./pages/patients/AddEdit')),auth:true  },
    { url: "/patients/detail/:id", Component: lazy(() => import('./pages/patients/View')),auth:true  },
    { url: "/patients/edit/:id", Component: lazy(() => import('./pages/patients/AddEdit')),auth:true  },
    
    { url: "/category",Component: lazy(() => import('./pages/categories')),auth:true  },
    { url: "/category/add", Component: lazy(() => import('./pages/categories/AddEdit')),auth:true  },
    { url: "/category/detail/:id", Component: lazy(() => import('./pages/categories/View')),auth:true  },
    { url: "/category/edit/:id", Component: lazy(() => import('./pages/categories/AddEdit')),auth:true  },
    { url: "/faq", Component: lazy(() => import('./pages/faq')),auth:true  },
    { url: "/faq/add", Component: lazy(() => import('./pages/faq/AddEdit')),auth:true  },
    { url: "/faq/detail/:id", Component: lazy(() => import('./pages/faq/View')),auth:true  },
    { url: "/faq/edit/:id", Component: lazy(() => import('./pages/faq/AddEdit')),auth:true },
    { url: "/content", Component: lazy(() => import('./pages/content')),auth:true  },
    { url: "/content/detail/:slug", Component: lazy(() => import('./pages/content/View')) ,auth:true },
    { url: "/content/add", Component: lazy(() => import('./pages/content/AddEdit')),auth:true  },
    { url: "/content/edit/:slug", Component: lazy(() => import('./pages/content/AddEdit')),auth:true  },    
    { url: "/users", Component: lazy(() => import('./pages/users')),auth:true  },
    { url: "/users/edit/:id",Component: lazy(() => import('./pages/users/AddEdit')),auth:true  },
    { url: "/users/add", Component: lazy(() => import('./pages/users/AddEdit')),auth:true },
    { url: "/users/detail/:id", Component: lazy(() => import('./pages/users/View')) ,auth:true }, 

    { url: "/affiliates", Component: lazy(() => import('./pages/Affiliatemanagement')), auth: true },
    { url: "/affiliates/edit/:id", Component: lazy(() => import('./pages/Affiliatemanagement/AddEdit')), auth: true },
    { url: "/affiliates/add", Component: lazy(() => import('./pages/Affiliatemanagement/AddEdit')), auth: true },
    { url: "/affiliates/detail/:id", Component: lazy(() => import('./pages/Affiliatemanagement/View')), auth: true },

    { url: "/theme", Component: lazy(() => import('./pages/theme')) ,auth:true },
    { url: "/theme/edit/:id", Component: lazy(() => import('./pages/theme/AddEdit')) ,auth:true },
    { url: "/theme/add", Component: lazy(() => import('./pages/theme/AddEdit')),auth:true  },
    { url: "/theme/detail/:id", Component: lazy(() => import('./pages/theme/View')),auth:true  }, 
    { url: "/subadmin", Component: lazy(() => import('./pages/subadmin')),auth:true },
    { url: "/subadmin/edit/:id", Component: lazy(() => import('./pages/subadmin/AddEdit')),auth:true  },
    { url: "/subadmin/add", Component: lazy(() => import('./pages/subadmin/AddEdit')),auth:true  },
    { url: "/subadmin/detail/:id", Component: lazy(() => import('./pages/subadmin/View')),auth:true  }, 
    { url: "/diettype", Component: lazy(() => import('./pages/diettype')),auth:true  },
    { url: "/diettype/edit/:id",Component: lazy(() => import('./pages/diettype/AddEdit')) ,auth:true },
    { url: "/diettype/add", Component: lazy(() => import('./pages/diettype/AddEdit')),auth:true },
    { url: "/diettype/detail/:id", Component: lazy(() => import('./pages/diettype/View')),auth:true  }, 
    { url: "/dietgoals", Component: lazy(() => import('./pages/dietgoals')),auth:true  },
    { url: "/dietgoals/edit/:id", Component: lazy(() => import('./pages/dietgoals/AddEdit')),auth:true },
    { url: "/dietgoals/add", Component: lazy(() => import('./pages/dietgoals/AddEdit')),auth:true  },
    { url: "/dietgoals/detail/:id", Component: lazy(() => import('./pages/dietgoals/View')),auth:true  },
    
    { url: "/banners", Component: lazy(() => import('./pages/Banner')),auth:true  },
    { url: "/banners/edit/:id", Component: lazy(() => import('./pages/Banner/AddEdit')),auth:true },
    { url: "/banners/add", Component: lazy(() => import('./pages/Banner/AddEdit')),auth:true  },
    { url: "/banners/detail/:id", Component: lazy(() => import('./pages/Banner/View')),auth:true  },
    
    { url: "/foodlist", Component: lazy(() => import('./pages/foodlist')),auth:true  },
    { url: "/video", Component: lazy(() => import('./pages/videos')),auth:true  },
    { url: "/video/add", Component: lazy(() => import('./pages/videos/AddEdit')),auth:true  },
    { url: "/video/edit/:id", Component: lazy(() => import('./pages/videos/AddEdit')),auth:true },
    { url: "/video/detail/:id", Component: lazy(() => import('./pages/videos/View')) ,auth:true },
    { url: "/blogs", Component: lazy(() => import('./pages/blogs')),auth:true  },
    { url: "/blogs/add", Component: lazy(() => import('./pages/blogs/AddEdit')),auth:true  },
    { url: "/blogs/edit/:id", Component: lazy(() => import('./pages/blogs/AddEdit')),auth:true },
    { url: "/blogs/detail/:id", Component: lazy(() => import('./pages/blogs/View')) ,auth:true },
    
    { url: "/recipies", Component: lazy(() => import('./pages/recipies')),auth:true  },
    { url: "/recipies/add", Component: lazy(() => import('./pages/recipies/AddEdit')),auth:true  },
    { url: "/recipies/edit/:id", Component: lazy(() => import('./pages/recipies/AddEdit')),auth:true },
    { url: "/recipies/detail/:id", Component: lazy(() => import('./pages/recipies/detail')) ,auth:true },
    
    { url: "/forums", Component: lazy(() => import('./pages/Forums')),auth:true  },
    { url: "/forums/add", Component: lazy(() => import('./pages/Forums/AddEdit')),auth:true  },
    { url: "/forums/edit/:id", Component: lazy(() => import('./pages/Forums/AddEdit')),auth:true },
    { url: "/forums/detail/:id", Component: lazy(() => import('./pages/Forums/View')) ,auth:true },
    
    { url: "/post/add", Component: lazy(() => import('./pages/blogs/AddEdit')),auth:true  },
    { url: "/post/edit/:id", Component: lazy(() => import('./pages/blogs/AddEdit')),auth:true },
    { url: "/post/detail/:id", Component: lazy(() => import('./pages/blogs/View')) ,auth:true },
    
    { url: "/Beginner/videos", Component: lazy(() => import('./pages/videos')),auth:true  },
    { url: "/Beginner/videos/add", Component: lazy(() => import('./pages/videos/AddEdit')),auth:true  },
    { url: "/Beginner/videos/edit/:id", Component: lazy(() => import('./pages/videos/AddEdit')),auth:true },
    { url: "/Beginner/videos/detail/:id", Component: lazy(() => import('./pages/videos/View')) ,auth:true },

    { url: "/HIIT/videos", Component: lazy(() => import('./pages/hiitvideos')),auth:true  },
    { url: "/HIIT/videos/add", Component: lazy(() => import('./pages/hiitvideos/AddEdit')),auth:true  },
    { url: "/HIIT/videos/edit/:id", Component: lazy(() => import('./pages/hiitvideos/AddEdit')),auth:true },
    { url: "/HIIT/videos/detail/:id", Component: lazy(() => import('./pages/hiitvideos/View')) ,auth:true },
  
    { url: "/reports", Component: lazy(() => import('./pages/report')),auth:true  },
    // { url: "/WeightTraining/videos/add", Component: lazy(() => import('./pages/weightVideos/AddEdit')),auth:true  },
    // { url: "/WeightTraining/videos/edit/:id", Component: lazy(() => import('./pages/weightVideos/AddEdit')),auth:true },
    { url: "/report/detail/:id", Component: lazy(() => import('./pages/report/detail')) ,auth:true },

    { url: "/forumreports", Component: lazy(() => import('./pages/reportForums')),auth:true  },
    // { url: "/WeightTraining/videos/add", Component: lazy(() => import('./pages/weightVideos/AddEdit')),auth:true  },
    // { url: "/WeightTraining/videos/edit/:id", Component: lazy(() => import('./pages/weightVideos/AddEdit')),auth:true },
    { url: "/forumreport/detail/:id", Component: lazy(() => import('./pages/reportForums/detail')) ,auth:true },

    { url: "/WeightTraining/videos", Component: lazy(() => import('./pages/weightVideos')),auth:true  },
    { url: "/WeightTraining/videos/add", Component: lazy(() => import('./pages/weightVideos/AddEdit')),auth:true  },
    { url: "/WeightTraining/videos/edit/:id", Component: lazy(() => import('./pages/weightVideos/AddEdit')),auth:true },
    { url: "/WeightTraining/videos/detail/:id", Component: lazy(() => import('./pages/weightVideos/View')) ,auth:true },
  
    { url: "/chats", Component: lazy(() => import('./pages/Chats')),auth:true  },
  ];

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={"loading ..."} persistor={persistor}>
        <Suspense
            fallback={
              <div className="loaderDiv">
                <div>
                  <img
                    src="/assets/img/loader.gif"
                    alt="logo"
                    className="loaderlogo"
                  />
                </div>
              </div>
            }
          >
          <Router>
            <Routes>
              {routes.map((itm:any) => {
                const Element:any=itm?.Component
                return <Route path={itm.url} element={<>
                <PageRoute url={itm.url} auth={itm.auth||false}>
                  {itm.element?itm.element:<Element/>}
                  </PageRoute>
                </>} />;
              })}
            </Routes>
          </Router>
          </Suspense>
        </PersistGate>
      </Provider>
      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
        </div>
      </div>
      <ToastContainer autoClose={2000}  position="top-right" />
    </>
  );
}

export default App;
